module.exports = __webpack_public_path__ + "static/media/placeholder.1c520709.png";